import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';

import { DynamicServiceDetailsForm } from '../components/service-details';
import {
  submitBooking,
  submitUserDetails,
  startLoading,
  getShopInfo,
} from '../state/actions/service';
import '../styles/service-description.scss';

function DynamicServiceDetails({ action = 'standard' }) {
  const history = useHistory();
  const dispatch = useDispatch();
  const service = useSelector((state) => state.service);
  const { shopid } = useParams();

  const typeId = action === 'Rental_out' ? 3 : action === 'Rental_in' ? 2 : 1;

  const onFormSubmitHandler = (data) => {
    dispatch(startLoading());
    dispatch(submitUserDetails(data));

    service.user = data;
    dispatch(submitBooking(service, history, typeId));
  };

  if (service.shop === undefined) {
    dispatch(getShopInfo(shopid, typeId));
  }

  return (
    <div className="container">
      <ServiceDescription shop={service.shop} action={action} />
      <DynamicServiceDetailsForm
        onSubmit={onFormSubmitHandler}
        schedules={service.schedules}
        slots={service.slots}
        isLoading={service.loading}
        errorMessage={service.error}
      />

      <div className="privacy-policy">
        <div>
          Jag godkänner härmed MIOO Cyclings <br />
          <div className="text-center">
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://mioo.cc/sv/om-mioo/integritetspolicy"
            >
              Integritetspolicy
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

function ServiceDescription({ shop, action }) {
  let introText;
  let infoText;

  if (action === 'Rental_out') {
    introText = `Här bokar du tid för upphämtning av din cykel hos ${shop?.name}, ${shop?.address}.`;
    infoText = 'Du hämtar cykeln på din bokade tid.';
  } else if (action === 'Rental_in') {
    introText = `Här bokar du tid för återlämning av din cykel hos ${shop?.name}, ${shop?.address}.`;
    infoText = 'Du lämnar tillbaka cykeln på din bokade tid.';
  } else {
    introText = `Här bokar du tid för inlämning av din cykel hos ${shop?.name}, ${shop?.address}.`;
    infoText = 'Du lämnar in cykeln på din bokade tid och får all övrig information på plats.';
  }

  return (
    <div className="service-description">
      <h1>Boka tid</h1>
      <div className="break-line" />

      <div>
        <p>{introText}</p>
        <p>{infoText}</p>
      </div>
    </div>
  );
}

export default DynamicServiceDetails;
